module.exports = __webpack_public_path__ + "img/partner_ad.a161e48c.jpg";